import React from "react";
import _ from "lodash";
import CoursesHit from "./Hit";
import ExpiringSoonFromHits from "./ExpiringSoonPanel";

const CoursesHits = ({
                       hits = [],
                       customHits = [],
                       addCourseToHits,
                       currentUserRole,
                       currentUserEmail,
                       onFocusCourse
                     }) => {
  const mappedHits = hits.map(h => h._source);
  const allHits = [...customHits, ...mappedHits];

  return (
    <div>
      <ExpiringSoonFromHits
        hits={allHits}
        currentUserEmail={currentUserEmail}
        onFocus={onFocusCourse}
        days={7}
        onlyMine={true}
      />

      {_.map(allHits, (hit, index) => (
        <CoursesHit
          key={`${hit.id}-${index}`}
          hit={hit}
          addCourseToHits={addCourseToHits}
          currentUserRole={currentUserRole}
        />
      ))}
    </div>
  );
};

export default CoursesHits;
